import React from "react";
import TextField from "@mui/material/TextField";
import { red } from "@mui/material/colors";
import { NumericFormat } from "react-number-format";
import PropTypes from "prop-types";
import { regexNumberCheck } from "../../utils/Common";

const NumericFormatCustom = React.forwardRef(function NumericFormatCustom(
  props,
  ref
) {
  const { onChange, ...other } = props;

  return (
    <NumericFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: String(values.value),
          },
        });
      }}
      thousandSeparator
      valueIsNumericString
    />
  );
});

NumericFormatCustom.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

const InputTextField = ({
  width = 160,
  required = false,
  autoComplete = "off",
  disabled = false,
  typeText = true,
  maxLength = 999,
  formatNumber = false,
  select = false,
  id,
  label,
  placeholder,
  name,
  value = "",
  onChange,
  onKeyPressEnter,
  variant,
  autoFocus,
  validation,
  fontSize,
  height,
  fontSizeInput,
  readOnly=false,
  ...props
}) => {
  const handleChange = (e) => {
    if (typeText) {
      onChange(e);
    } else if (regexNumberCheck(e.target.value)) {
      onChange(e);
    }
  };

  const handleKeyUp = (e) => {
    if (e.key === "Enter" && typeof onKeyPressEnter === "function") {
      onKeyPressEnter(e);
    }
  };

  return (
    <TextField
      disabled={disabled}
      error={!!validation}
      required={required}
      id={id}
      label={label}
      placeholder={placeholder}
      name={name}
      value={value}
      onChange={handleChange}
      onKeyUp={handleKeyUp}
      variant={variant ? "filled" : "outlined"}
      autoComplete={autoComplete}
      autoFocus={autoFocus}
      select={select}
      size="small"
      InputProps={{
        readOnly: readOnly,
        inputComponent: formatNumber ? NumericFormatCustom : undefined,
        style: {
          fontSize: fontSize ?? "13px",
          height: height ?? "35px",
        },
      }}
      inputProps={{
        maxLength,
      }}
      InputLabelProps={{
        style: {
          fontSize: fontSize ?? "12px",
          color: required ? red[600] : "#000000",
        },
      }}
      helperText={validation}
      sx={{
        m: 1,
        width,
        ...(required && {
          "& .MuiInputLabel-root": { color: red[600] },
          "& .MuiInputLabel-root.Mui-focused": { color: red[600] },
        }),
        "& .MuiOutlinedInput-input": {
          height: "100%",
          padding: "4px 8px",
          fontSize: fontSizeInput ?? "13px",
        },
      }}
      {...props}
    />
  );
};

export default React.memo(InputTextField);
